import { FieldType, Field, ComparisonOperator } from "../../vforms-model";
import { MultipleSelectionListComponent } from "./multiple-selection-list.component";
import { SelectionList } from "../selection-list";
import { SingleSelectionListEditorComponent } from "../single-selection-list/single-selection-list-editor.component";
import { ComparisonExpression } from "../../expression-settings/model";
import { get } from "lodash";

export class MultipleSelectionListType extends FieldType {
    static Id = "multiple-selection-list";

    constructor() {
        super();
        this.id = MultipleSelectionListType.Id;
        this.icon = "mat_outline:checklist";
        this.previewComponent = MultipleSelectionListComponent;
        this.editorComponent = SingleSelectionListEditorComponent;
    }

    createField(): Field {
        return new SelectionList(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Contains, ComparisonOperator.NotContains];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let selection: {} = value ?? {};
        switch (expression.operator) {
            case ComparisonOperator.Contains:
                let v = get(selection, expression.value);
                return v && v === true;
            case ComparisonOperator.NotContains:
                let v1 = get(selection, expression.value);
                return !v1 || v1 === false;
        }

        return super.evaluate(expression, value);
    }
}
